import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ spacing }: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: spacing(3, 2),
    maxWidth: 516,
  },
}));

export const useContainerStyles = makeStyles()({
  root: {
    width: '100%',
  },
});
